import fetch from 'isomorphic-fetch';
import fetchAPI from 'utils/fetchAPI';

export const FETCH_AVAILABLE_PRODUCTS = 'FETCH_AVAILABLE_PRODUCTS';
export const RECEIVED_AVAILABLE_PRODUCTS = 'RECEIVED_AVAILABLE_PRODUCTS';
export const RECEIVED_AVAILABLE_PLANS = 'RECEIVED_AVAILABLE_PLANS';

export function receivedAvailableProducts(products) {
  return {
    type: RECEIVED_AVAILABLE_PRODUCTS,
    products,
  };
}

function receivedAvailablePlans(plans) {
  return {
    type: RECEIVED_AVAILABLE_PLANS,
    plans,
  };
}

export function fetchAvailableProducts() {
  return (dispatch, getState) =>
    new Promise((resolve, reject) => {
      const token = getState().users.token;

      fetch(`${__API_HOST__}/api/v1.1/subscriptions/products`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      })
        .then(response => response.json())
        .then(json => {
          dispatch(receivedAvailableProducts(json.data));
        })
        .catch(ex => reject(ex));
    });
}

export function fetchAvailablePlans() {
  return (dispatch, getState) =>
    new Promise((resolve, reject) => {
      const token = getState().users.token;

      fetch(`${__API_HOST__}/api/v1.1/subscriptions/plans`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      })
        .then(response => response.json())
        .then(json => {
          dispatch(receivedAvailablePlans(json.data));
        })
        .catch(ex => reject(ex));
    });
}



// WEBPACK FOOTER //
// ./app/actions/SubscriptionsActionCreators.js